const NAMESPACE = "documentGeneration";

const KEYS = {
    generateDocumentButtonLabel: "generateDocumentButtonLabel",
    templateNotConfigured: "templateNotConfigured",
    documentGenerationDisabled: "documentGenerationDisabled"
};

const MESSAGES = {
    [KEYS.generateDocumentButtonLabel]: {
        value: "Generate Document",
        comment: "Label for button which generates a document when clicked"
    },
    [KEYS.templateNotConfigured]: {
        value: "Document Template Not Configured: ",
        comment: "Message communicating that the form element was not properly configured"
    },
    [KEYS.documentGenerationDisabled]: {
        value: "Document Generation Disabled",
        comment: "Error message explaining the effects of the element not being properly configured."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
